import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styled from "styled-components";

// Definindo as props que o componente irá receber
interface MediaCardProps {
  title: string;
  description: string;
  imageUrl: string;
  icone?: React.ReactNode;
  actions?: React.ReactNode;
  serv?: string;
}

// Conteiner responsivo
const Conteiner = styled.div`
  display: flex; 
  align-items: center; 
  width: 100%; // Largura total do container
  // Outros estilos necessários
`

// Ajustando os estilos para Linha1 e Linha2 para serem responsivos
const Linha1 = styled.div`
  flex: 0 0 auto; // Tamanho flexível
  margin-right: 5px;
  margin-top: 5px;
`

const Linha2 = styled.div`
  flex-grow: 1; // Cresce para preencher o espaço disponível
`

export default function CardServico({ title, description, imageUrl, icone, actions, serv }: MediaCardProps) {
  return (
    <Card sx={{ width: '100%', marginBottom: 3, backgroundColor: '#f4f8f8', marginLeft: 5 }}>
      <CardContent>
        <Conteiner>
          <Linha1>
            {icone}
          </Linha1>
          <Linha2>
            <Typography gutterBottom variant="h5" component="div">
              <strong>{title}</strong>
            </Typography>
          </Linha2>
        </Conteiner>

        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        <br />
        <Typography variant="caption" gutterBottom>
          <strong>{serv}</strong>
        </Typography>
      </CardContent>
      {/* Opções de ações, se necessário */}
    </Card>
  );
}
